<template>
    <div  id="invoicingadmin_container">
        <!--<Header></Header>-->
        <Navigation v-show="isLoggedIn"></Navigation>
        <Breadcrumb v-if="isLoggedIn" />
        <slideout-panel></slideout-panel>
        <slot />
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from "@/components/Header";
    import Breadcrumb from "@/components/Breadcrumb";
    import Navigation from "@/components/InvoicingAdminNavigation";
    import Footer from "@/components/Footer";
    export default {
        name: "LayoutBasic",
        components: {
            Header,
            Navigation,
            Footer,
            Breadcrumb
        },
        computed: {
            isLoggedIn: function() {
                return this.$store.getters.isLoggedIn;
            }
        }
    };
</script>
